import React from 'react'

import './_description-list.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'dl'>,
  {
    children?: React.ReactNode
    alignRight?: boolean
    alternateRows?: boolean
    noRowGap?: boolean
  }
>

const DescriptionList = ({
  className,
  alignRight = false,
  children,
  alternateRows = false,
  noRowGap = false,
  ...props
}: Props) => (
  <dl
    {...props}
    className={cn('DescriptionList', {alignRight, alternateRows, noRowGap}, className)}
  >
    {children}
  </dl>
)

export default DescriptionList
